"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.providerMappingSlice = providerMappingSlice;
const appConstants_1 = require("../../constants/appConstants");
const PROVIDER_MAPPING_OPTIONS = appConstants_1.codingListConstants.providerMappingOptions;
const providerMappingInitialState = {
    providerMapping: {
        options: PROVIDER_MAPPING_OPTIONS.map(value => ({
            id: value.toLowerCase().replace(' ', ''),
            label: value,
        })),
        currentSelectedProviderMapOption: {
            id: appConstants_1.codingListConstants.providerMappingNoneOption || '', // !! la GET NU AFISEZ CORESPONDING MAPPING
            label: 'Not Mapped',
        },
    },
};
function providerMappingSlice(set) {
    return {
        ...providerMappingInitialState,
        setCurrentSelectedProviderMapOption(currentSelectedProviderMapOption) {
            set((state) => {
                state.providerMapping.currentSelectedProviderMapOption = currentSelectedProviderMapOption;
                return state;
            }, false, '[setCurrentSelectedProviderMapOption]');
        },
    };
}
